document.addEventListener('DOMContentLoaded', function() {
  // Desktop Dropdown Toggle
  const navDropdown = document.querySelector('.nav-item-dropdown');
  const shopNavLink = document.querySelector('.nav-item-dropdown .nav-link');

  if (navDropdown && shopNavLink) {
    shopNavLink.addEventListener('click', function(e) {
      e.preventDefault();
      navDropdown.classList.toggle('active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!navDropdown.contains(e.target)) {
        navDropdown.classList.remove('active');
      }
    });
  }

  // Sliding Menu Toggle
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const slidingMenu = document.querySelector('.sliding-menu');
  const menuOverlay = document.querySelector('.menu-overlay');
  const closeMenu = document.querySelector('.close-menu');
  const mobileNav = document.querySelector('.mobile-nav');

  // Open sliding menu
  if (menuToggle && slidingMenu && menuOverlay) {
    menuToggle.addEventListener('click', function() {
      const isActive = slidingMenu.classList.contains('active');

      if (isActive) {
        // Close menu
        slidingMenu.classList.remove('active');
        menuOverlay.classList.remove('active');
        document.body.style.overflow = '';

        // Reset hamburger
        const lines = menuToggle.querySelectorAll('.hamburger-line');
        lines[0].style.transform = 'none';
        lines[1].style.opacity = '1';
        lines[2].style.transform = 'none';
      } else {
        // Open menu
        slidingMenu.classList.add('active');
        menuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Animate hamburger
        const lines = menuToggle.querySelectorAll('.hamburger-line');
        lines[0].style.transform = 'translateY(7px) rotate(45deg)';
        lines[1].style.opacity = '0';
        lines[2].style.transform = 'translateY(-7px) rotate(-45deg)';
      }
    });
  }

  // Close menu via close button
  if (closeMenu && slidingMenu && menuOverlay) {
    closeMenu.addEventListener('click', function() {
      slidingMenu.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';

      // Reset hamburger
      const lines = menuToggle.querySelectorAll('.hamburger-line');
      lines[0].style.transform = 'none';
      lines[1].style.opacity = '1';
      lines[2].style.transform = 'none';
    });
  }

  // Close menu via overlay click
  if (menuOverlay && slidingMenu) {
    menuOverlay.addEventListener('click', function() {
      slidingMenu.classList.remove('active');
      menuOverlay.classList.remove('active');
      document.body.style.overflow = '';

      // Reset hamburger
      const lines = menuToggle.querySelectorAll('.hamburger-line');
      lines[0].style.transform = 'none';
      lines[1].style.opacity = '1';
      lines[2].style.transform = 'none';
    });
  }

  // Shop submenu toggle
  const shopToggle = document.querySelector('.shop-toggle');
  const submenuCollections = document.querySelector('.submenu-collections');

  if (shopToggle && submenuCollections) {
    shopToggle.addEventListener('click', function() {
      submenuCollections.classList.toggle('active');
    });
  }

  // Video Slider
  const sliderWrapper = document.querySelector('.video-slider-wrapper');
  const slides = document.querySelectorAll('.video-slide');
  const prevBtn = document.querySelector('.slider-prev');
  const nextBtn = document.querySelector('.slider-next');
  const dots = document.querySelectorAll('.slider-dot');
  const videos = document.querySelectorAll('.slider-video');
  const fullscreenBtns = document.querySelectorAll('.fullscreen-btn');
  const muteBtns = document.querySelectorAll('.mute-btn');

  let currentSlide = 0;

  function goToSlide(index) {
    if (!sliderWrapper || slides.length === 0) return;

    currentSlide = index;

    // Get the actual width of the first slide (they should all be the same)
    const slideWidth = slides[0].offsetWidth;
    const offset = currentSlide * slideWidth;

    sliderWrapper.style.transform = `translateX(-${offset}px)`;

    // Pause and mute all videos except current
    videos.forEach((video, i) => {
      if (i === currentSlide) {
        video.play();
      } else {
        video.pause();
        video.muted = true;
        // Update mute button icon for skipped videos
        updateMuteIcon(i);
      }
    });

    // Update active dot
    dots.forEach((dot, i) => {
      if (i === currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  function updateMuteIcon(index) {
    if (!muteBtns[index]) return;
    const video = videos[index];
    const mutedIcon = muteBtns[index].querySelector('.muted-icon');
    const unmutedIcon = muteBtns[index].querySelector('.unmuted-icon');

    if (video.muted) {
      mutedIcon.style.display = 'block';
      unmutedIcon.style.display = 'none';
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = 'block';
    }
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    goToSlide(currentSlide);
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    goToSlide(currentSlide);
  }

  // Next/Prev button events
  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  // Mute/Unmute functionality
  muteBtns.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      const video = videos[index];
      video.muted = !video.muted;
      updateMuteIcon(index);
    });
  });

  // Fullscreen functionality
  fullscreenBtns.forEach((btn, index) => {
    btn.addEventListener('click', function() {
      const video = videos[index];

      // Unmute when entering fullscreen
      video.muted = false;
      updateMuteIcon(index);

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        // iOS Safari support
        video.webkitEnterFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    });
  });

  // Mute videos when exiting fullscreen
  document.addEventListener('fullscreenchange', function() {
    if (!document.fullscreenElement) {
      videos.forEach((video, i) => {
        video.muted = true;
        updateMuteIcon(i);
      });
    }
  });

  document.addEventListener('webkitfullscreenchange', function() {
    if (!document.webkitFullscreenElement) {
      videos.forEach((video, i) => {
        video.muted = true;
        updateMuteIcon(i);
      });
    }
  });

  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  if (sliderWrapper) {
    sliderWrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    sliderWrapper.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
  }

  function handleSwipe() {
    if (touchEndX < touchStartX - 50) {
      nextSlide();
    }
    if (touchEndX > touchStartX + 50) {
      prevSlide();
    }
  }

  // Recalculate slide position on window resize
  window.addEventListener('resize', function() {
    if (sliderWrapper && slides.length > 0) {
      goToSlide(currentSlide);
    }
  });

  // Product Page - Image Slider
  const productSliderWrapper = document.querySelector('.product-slider-wrapper');
  const productSlides = document.querySelectorAll('.product-slide');
  const productPrevBtn = document.querySelector('.product-slider-prev');
  const productNextBtn = document.querySelector('.product-slider-next');
  const productDots = document.querySelectorAll('.product-slider-dot');

  let currentProductSlide = 0;

  function goToProductSlide(index) {
    if (!productSliderWrapper || productSlides.length === 0) return;

    currentProductSlide = index;

    const slideWidth = productSlides[0].offsetWidth;
    const offset = currentProductSlide * slideWidth;

    productSliderWrapper.style.transform = `translateX(-${offset}px)`;

    // Update active dot
    productDots.forEach((dot, i) => {
      if (i === currentProductSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  function nextProductSlide() {
    currentProductSlide = (currentProductSlide + 1) % productSlides.length;
    goToProductSlide(currentProductSlide);
  }

  function prevProductSlide() {
    currentProductSlide = (currentProductSlide - 1 + productSlides.length) % productSlides.length;
    goToProductSlide(currentProductSlide);
  }

  // Next/Prev button events
  if (productNextBtn) {
    productNextBtn.addEventListener('click', nextProductSlide);
  }

  if (productPrevBtn) {
    productPrevBtn.addEventListener('click', prevProductSlide);
  }

  // Dot navigation
  productDots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToProductSlide(index));
  });

  // Touch/swipe support for product slider
  let productTouchStartX = 0;
  let productTouchEndX = 0;

  if (productSliderWrapper) {
    productSliderWrapper.addEventListener('touchstart', (e) => {
      productTouchStartX = e.changedTouches[0].screenX;
    });

    productSliderWrapper.addEventListener('touchend', (e) => {
      productTouchEndX = e.changedTouches[0].screenX;
      handleProductSwipe();
    });
  }

  function handleProductSwipe() {
    if (productTouchEndX < productTouchStartX - 50) {
      nextProductSlide();
    }
    if (productTouchEndX > productTouchStartX + 50) {
      prevProductSlide();
    }
  }

  // Recalculate product slide position on window resize
  window.addEventListener('resize', function() {
    if (productSliderWrapper && productSlides.length > 0) {
      goToProductSlide(currentProductSlide);
    }
  });

  // Variant selector - change image on variant selection
  const variantSelector = document.querySelector('#productSelect');
  if (variantSelector && productSlides.length > 0) {
    variantSelector.addEventListener('change', function() {
      // Find the variant's featured image URL from the data attribute
      const selectedOption = this.options[this.selectedIndex];
      const variantImageUrl = selectedOption.getAttribute('data-variant-image');

      if (variantImageUrl) {
        // Extract image ID from URL (the part before the file extension and size parameters)
        const getImageId = (url) => {
          if (!url) return null;
          // Extract the filename part before size/version parameters
          const match = url.match(/\/([^\/]+?)(?:_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d+))?\.(jpg|jpeg|png|gif|webp)/i);
          return match ? match[1] : null;
        };

        const variantImageId = getImageId(variantImageUrl);

        // Find the slide with matching image
        productSlides.forEach((slide, index) => {
          const slideImage = slide.querySelector('.product-slider-image');
          if (slideImage) {
            const slideImageId = getImageId(slideImage.src);
            if (slideImageId && variantImageId && slideImageId === variantImageId) {
              goToProductSlide(index);
            }
          }
        });
      }
    });
  }

  // Add to Cart - Success Feedback
  const addToCartForm = document.querySelector('#AddToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      const submitButton = this.querySelector('#AddToCart');
      const originalText = submitButton.textContent;

      submitButton.textContent = 'Adding...';
      submitButton.disabled = true;

      // Re-enable after form submits
      setTimeout(function() {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      }, 2000);
    });
  }
});
